<div class="profile-page bg-secondary">
    <main class="pt-3">
        <div class="container wow fadeIn">
            <legend>Customer Transactions Report</legend>
            <!--Grid row-->
            <b-row>
                <b-col sm="12" md="6">
                    <b-form-group label="From Date:" label-for="input-1">
                        <datepicker v-model="fromDate" input-class="form-control" :format="customFormatter"
                            placeholder="Select from date"></datepicker>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="6">
                    <b-form-group label="To Date:" label-for="input-1">
                        <datepicker v-model="toDate" input-class="form-control" :format="customFormatter"
                            placeholder="Select from date"></datepicker>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="6">
                    <b-form-group label="Customer leave empty for all:" label-for="input-1">
                        <b-form-input v-model="customer" input-class="form-control"
                            placeholder="Select from date"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="6">
                    <b-button type="button" @click="getTransactions" variant="primary">
                        Retrieve Report
                    </b-button>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <strong>Total Transactions</strong>
                </b-col>
                <b-col>
                    {{totalTransactions}}
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <strong>Total Discount Received</strong>
                </b-col>
                <b-col>
                    {{currency}}{{totalDiscountReceived}}
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <strong>Total Sales Value</strong>
                </b-col>
                <b-col>
                    {{currency}}{{totalSalesValue}}
                </b-col>
            </b-row>
            <div class="row pt-3">
                <div class="table-responsive">
                    <b-table striped hover bordered :items="items" :fields="fields">
                        <template #cell(month)="data">
                            <span>{{monthInFull(data.item.month)}}</span>
                        </template>
                        <template #cell(discountReceived)="data">
                            <span>{{currency}}{{data.item.discountReceived}}</span>
                        </template>
                        <template #cell(salesValue)="data">
                            <span>{{currency}}{{data.item.salesValue}}</span>
                        </template>
                    </b-table>
                    <br />
                    <b-pagination @input="handlePageClick" v-model="selectedPage" :total-rows="totalRecords"
                        :per-page="perPage" first-number last-number></b-pagination>
                </div>
            </div>
            <!--spinner-->
            <div class="vld-parent">
                <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
            </div>
            <!--spinner-->
            <!--Grid row-->
        </div>
    </main>
    <!--Main layout-->
</div>